import classNames from 'classnames';
import { MappingPanelPosition } from '../../MappingEditorStore';
import { LEFT_COLUMN_EDGE } from '../MappingConnectors';

export interface IDraggingMappingConnectorDragProps {
  startSide: MappingPanelPosition;
  startY: number;
  hitY?: number;
  hitSide?: MappingPanelPosition;
}

export interface IDraggingMappingConnectorProps extends IDraggingMappingConnectorDragProps {
  endX: number;
  endY: number;
  isRowHovered?: boolean;
  rightEdge: number;
  reallyDragging?: boolean;
}

const getClassName = () => classNames('dp-dragging-mapping-connector');

const getClassNameForCircle = (isRowHovered = false) => classNames(`dp-dragging-mapping-connector__point`);

/**
 * Just render a connector line for a _potential_ new connection.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function DraggingMappingConnector({
  endX,
  endY,
  hitY,
  hitSide,
  rightEdge,
  startSide,
  startY,
  isRowHovered,
  reallyDragging,
}: IDraggingMappingConnectorProps) {
  // these won't have a truthy hitY if nothing is hit, so it works as a hit check
  const x2 = hitY ? (hitSide === MappingPanelPosition.LEFT ? LEFT_COLUMN_EDGE : rightEdge) : endX;
  const startX = startSide === MappingPanelPosition.LEFT ? LEFT_COLUMN_EDGE : rightEdge;
  return (
    <g className={getClassName()}>
      {reallyDragging && (
        <line x1={startX} y1={startY} x2={x2} y2={hitY || endY} className="dp-dragging-mapping-connector__line" />
      )}
      <circle cx={startX} cy={startY} r="4" fill="white" className={getClassNameForCircle(isRowHovered)} />
      {hitY && <circle cx={x2} cy={hitY} r="4" fill="white" className={'dp-dragging-mapping-connector__point'} />}
    </g>
  );
}
